import React, { useEffect, useState } from "react";
import {
  CircularProgressbarWithChildren,
  buildStyles,
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { Arc, Habit, db } from "../services/db";
import feather from "feather-icons";

interface ArcListProps {
  arcs: Arc[];
  updated: boolean
}

const ChallengesList: React.FC<ArcListProps> = ({ arcs, updated }) => {
  const [completionPercentages, setCompletionPercentages] = useState<
    Map<string, number[]>
  >(new Map());

  console.log('arcs ok: ', arcs);

  const arcAndHabits = new Map<string, Habit[]>();

  useEffect(() => {
    fetch();
    feather.replace();
  }, [updated]);

  const [arcColors, setArcColors] = useState<Record<string, string>>({});

  const fetch = async () => {
    try {
      const arcCompletionMap = new Map<string, number[]>();

      const tempArcColors: Record<string, string> = {};

      // Calculate completion percentage for each arc
      for (const arc of arcs) {
        tempArcColors[arc.name] = arc.color;
        console.log("arcname: ", arc, tempArcColors);
        const completionPercentageArray: number[] = [];
        const startDate = new Date(arc.startDate);
        const endDate = new Date(
          startDate.getTime() + parseInt(arc.timePeriod) * 24 * 60 * 60 * 1000
        ); // Calculate end date based on start date and time period

        // Loop through each day within the time period
        const currentDate = new Date(startDate);
        while (currentDate < endDate) {
          // const dateString = currentDate.toISOString().split("T")[0];

          // Fetch habits completed on the current date
          const habitsForDate = await db.getHabitsByDateAndArcId(
            currentDate,
            arc.arcId
          );
          // console.log("db:: ", habitsForDate);
          // Calculate completion percentage for the current date
          const completedHabitsCount = habitsForDate.length;

          const completionPercentage =
            arc.habits.length > 0
              ? (completedHabitsCount / arc.habits?.length) * 100
              : 0;

          completionPercentageArray.push(completionPercentage);

          // Move to the next day
          currentDate.setDate(currentDate.getDate() + 1);
        }

        arcCompletionMap.set(arc.name, completionPercentageArray);
        arcAndHabits.set(arc.name, arc.habits);
      }

      setArcColors(tempArcColors);

      console.log("arcCompletionMap: ", arcCompletionMap);
      setCompletionPercentages(arcCompletionMap);
    } catch (error) {
      console.error("Error fetching habits for today:", error);
    }
  };

  // Function to generate a random color
  const getRandomColor = () => {
    const randomColor = Math.floor(Math.random() * 16777215).toString(16);
    return "#" + randomColor;
  };

  const allHabitsCompleted = (arc: Arc) => {
    return arc.habits.every((habit) => habit.completed);
  };

  console.log("colll ", arcColors);
  console.log("ab");
  // Store colors for each arc

  return (
    <div style={{ overflowX: "auto" }} className="bg-white ">
      <h2 className="text-3xl pl-2 my-4 font-bold">My Challenges</h2>
      {completionPercentages.size > 0 ? (
        Array.from(completionPercentages.entries()).map(
          ([arcName, completionPercentageArray], index) => (
            <div key={index} style={{ margin: 10 }} className="pt-2">
              <h3 className="text-xl font-semibold pl-3">
                {arcName}
              </h3>

              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "wrap",
                }}
                className="p-2 bg-gray-900 rounded-xl mx-2"
              >
                {completionPercentageArray.every(
                  (percentage) => percentage === 100
                ) ? (
                  <div
                    key={index}
                    className="w-1/12 mr-4 ml-3 my-2 p-2 bg-gray-700 rounded-2xl mt-4 flex flex-col justify-center items-center gap-2 border-2 border-slate-600"
                  >
                    <span className="text-[#00FF00]">Completed</span>
                    <CircularProgressbarWithChildren
                      circleRatio={1}
                      value={100}
                      text={`100%`}
                      strokeWidth={10}
                      styles={buildStyles({
                        pathColor: '#00FF00', // Use consistent color for each arc
                        trailColor: "transparent",
                      })}
                    ></CircularProgressbarWithChildren>

                  </div>
                ) : null}

                {completionPercentageArray.map((percentage, index) => (
                  <div
                    key={index}
                    className="w-1/12 mr-4 ml-3 my-2 p-2 bg-gray-700 rounded-2xl mt-4 flex flex-col justify-center items-center gap-2 border-2 border-slate-600"
                  >
                    <span className="text-white">Day {index + 1}</span>
                    {/* <span>{arcAndHabits[arcName]}</span> */}
                    <CircularProgressbarWithChildren
                      circleRatio={1}
                      value={percentage}
                      text={`${percentage.toFixed(0)}%`}
                      strokeWidth={10}
                      styles={buildStyles({
                        pathColor: arcColors[arcName], // Use consistent color for each arc
                        trailColor: "transparent",
                      })}
                    ></CircularProgressbarWithChildren>
                  </div>
                ))}
              </div>
            </div>
          )
        )
      ) : (
        <p>No arcs available.</p>
      )}
    </div>
  );
};

export default ChallengesList;
